export default {
    path: 'flash-sale',
    component: () => import('../FlashSale.vue'),
    children: [
        {
            path: '',
            name: 'Danh sách Flash Sale',
            component: () => import('../table/Table.vue')
        },
        {
            path: 'cu',
            name: 'Tạo Flash Sale',
            component: () => import('../cu/CU.vue'),
        },
        {
            path: 'cu/:id',
            name: 'Chi tiết Flash Sale',
            component: () => import('../cu/CU.vue'),
        },
    ]
};